import { colors } from 'assets/styled/tokens';
import styled, { css } from 'styled-components';
import { modalTokens } from './tokens';

export interface ModalAnimatedProps {
  'data-entering'?: boolean;
  'data-exiting'?: boolean;
}

// Mixin de transição de entrada/saída (fade + leve scale). Aplique em qualquer
// styled-component que sirva de caixa de conteúdo de um `Modal` — a caixa mantém
// toda a sua estilização própria, só ganha essas 3 propriedades.
export const modalContentTransitionCss = css<ModalAnimatedProps>`
  opacity: ${p => (p['data-entering'] || p['data-exiting'] ? 0 : 1)};
  transform: ${p => (p['data-entering'] || p['data-exiting'] ? 'scale(0.96)' : 'scale(1)')};
  transition:
    opacity ${modalTokens.transitionDurationMs}ms ease-in-out,
    transform ${modalTokens.transitionDurationMs}ms ease-in-out;
`;

export const TransparentBg = styled.div<ModalAnimatedProps>`
  background: rgba(0, 0, 0, ${modalTokens.backdropOpacity});
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: ${modalTokens.zIndex};
  overflow-y: auto;
  padding: 0 16px;
  opacity: ${p => (p['data-entering'] || p['data-exiting'] ? 0 : 1)};
  transition: opacity ${modalTokens.transitionDurationMs}ms ease-in-out;
`;

export const ModalBody = styled.div<ModalAnimatedProps>`
  height: auto;
  width: 100%;
  max-width: 448px;
  min-width: 0;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  ${modalContentTransitionCss}
`;

export const Header = styled.div`
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #e8e1de;
  display: flex;
  flex-direction: row;
  padding: 15px;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  font-family: Blinker;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.5px;
  vertical-align: middle;
  color: ${colors.primary};
`;

export const CloseModalButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e8e1de;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
